// @ts-nocheck
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.$addButton = this.querySelector('[name="add"]')
    if (this.$addButton) this.$addButton.addEventListener('click', (event) => {
      this.handleAddToCart();
    })

    this.$productForm = document.querySelector('product-form')
    if (this.$productForm) this.$productForm.submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.handleAddToCart();
    })

    // Price update handling
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    this.$stickyPrice = this.querySelector('.sticky-add-to-cart__price');
    this.$stickyCompare = this.querySelector('.sticky-add-to-cart__compare');
    this.storedProductObject = { };
    this.storedProductCompareObject = { };

    if (this.dataset.price) {
      const price = parseInt(this.dataset.price, 10);
      const compare = parseInt(this.dataset.compare, 10);
      this.storedProductObject.Main = price;
      this.storedProductCompareObject.Main = compare > price ? compare : price;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (message) => {
      this.handleVariantChange(message.data);
    })

    this.$$bundleCards = document.querySelectorAll('bundle-card')
    this.$$bundleCards.forEach(($bundleCard) => 
      $bundleCard.addEventListener('variant-change', (event) => {
        this.handleVariantChange(event.detail);
      })
    )
  }

  async handleAddToCart() {
    this.$addButton.setAttribute('aria-disabled', true);
    this.$addButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    // grab bundle cards and add active ones to cart
    const payload = { items: [] }
    this.$$bundleCards.forEach(($bundleCard) => {
      if (!$bundleCard.selectedVariantId) return

      payload.items.push({
        id: $bundleCard.selectedVariantId,
        quantity: 1
      })
    })

    if (payload.items.length) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
    }

    // trigger main add to cart
    if (this.$productForm) {
      const productFormPromise = new Promise((resolve) => 
        this.$productForm.addEventListener('submit-finished', resolve))
      this.$productForm.form.dispatchEvent(new Event('submit'))
      await productFormPromise
    }

    this.$addButton.setAttribute('aria-disabled', false);
    this.$addButton.classList.remove('loading');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  toggleAddButton(disable = true, text) {
    const $addButtonText = this.$addButton.querySelector('span');
    if (!this.$addButton) return;

    if (disable) {
      this.$addButton.setAttribute('disabled', 'disabled');
      if (text) $addButtonText.textContent = text;
    } else {
      this.$addButton.removeAttribute('disabled');
      $addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  handleVariantChange(data) {
     console.log('handleVariantChange', data)
    if (!data.productId) {
      this.storedProductObject.Main = data.variant.price
      this.storedProductCompareObject.Main = (data.variant.compare_at_price && data.variant.compare_at_price > data.variant.price) ? data.variant.compare_at_price : data.variant.price
      this.toggleAddButton(!data.variant.available, window.variantStrings.soldOut)
      
    } else {
      this.storedProductObject[data.productId] = data.variant? data.variant.price : 0
      this.storedProductCompareObject[data.productId] = data.variant? (data.variant.compare_at_price && (data.variant.compare_at_price > data.variant.price) ? data.variant.compare_at_price : data.variant.price) : 0
    }
    let objectValues = Object.values(this.storedProductObject)
    let totalPrice = objectValues.reduce((acc, val) => acc + val, 0)
    this.$stickyPrice.innerText = this.formatter.format(totalPrice/100)

    let objectCompareValues = Object.values(this.storedProductCompareObject)
    let totalComparePrice = objectCompareValues.reduce((acc, val) => acc + val, 0)
    if (totalComparePrice > totalPrice) {
      this.$stickyCompare.classList.remove('hidden')
      this.$stickyCompare.innerText = this.formatter.format(totalComparePrice/100)
    } else {
      this.$stickyCompare.classList.add('hidden')
      this.$stickyCompare.innerText = ''
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart); 